import { render, staticRenderFns } from "./UnfinishedInvoiceModal.vue?vue&type=template&id=518b3fd4&"
import script from "./UnfinishedInvoiceModal.vue?vue&type=script&lang=ts&"
export * from "./UnfinishedInvoiceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports